import { MaterialCommunityIcons } from '@expo/vector-icons';

import type { Icon } from './internal';

export const Filter: Icon = ({ color = '#000000', size = 24 }) => (
  <MaterialCommunityIcons name="filter-outline" size={size} color={color} />
);
